import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import styled from 'styled-components';
import Slider from 'react-styled-carousel';
import Layout from '../components/shared/Layout';
import MetaHead from '../components/shared/MetaHead';

const query = graphql`
  query {
    image1: file(relativePath: { eq: "image1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image2: file(relativePath: { eq: "image2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image3: file(relativePath: { eq: "image3.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image4: file(relativePath: { eq: "image4.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image5: file(relativePath: { eq: "image5.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image6: file(relativePath: { eq: "image6.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image7: file(relativePath: { eq: "image7.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    image8: file(relativePath: { eq: "image8.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;

const IMAGES = 8;

const Dot = styled.li.attrs({
  children: ({ onClick }) => <button onClick={onClick} type="button"></button> // eslint-disable-line react/prop-types
})`
  display: inline-block;
  pointer-events: none;
  button {
    pointer-events: all;
    width: 3rem;
    height: 0.5rem;
    margin: 0 1px;
    background: ${({ active }) => (active ? '#ed1b24' : '#ddd')};
    border: 0;
    transition: all 0.3s;
    cursor: pointer;
    outline: none;

    :hover {
      background: #000000;
    }
  }
`;

const IndexPage = () => {
  const data = useStaticQuery(query);
  return (
    <Layout>
      <MetaHead title="Hansen-Byg v/ murermester Thomas Bruun Hansen" />
      <Slider showArrows={false} cardsToShow={1} padding="0px" Dot={<Dot />}>
        {new Array(IMAGES).fill('').map((n, i) => (
          <Img
            key={`image${i + 1}`}
            fluid={data[`image${i + 1}`].childImageSharp.fluid}
          />
        ))}
      </Slider>
    </Layout>
  );
};

export default IndexPage;
